import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestSection() {
  const latestComics = comics.slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-base italic font-heading text-foreground-500">
              每日新鲜 · 追更不停
            </p>
          </div>
          <div className="md:max-w-md">
            <p className="text-sm text-foreground-500 leading-relaxed">
              我们每日更新热门韩漫资源，涵盖恋爱、悬疑、动作、奇幻等多种类型。无论你喜欢什么风格，都能在这里找到心仪的作品，享受免费在线阅读的乐趣。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="default" />
          ))}
        </div>

        <div className="flex items-center justify-center mt-10">
          <Link
            to="/category/all?sort=newest"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-50 hover:border-foreground-400 transition-colors whitespace-nowrap"
          >
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}